import { createAction, deleteAction, readAction, updateAction } from "../components/utility";

const _crudActionsMap = {
    [createAction]: 'create',
    [readAction]: 'read',
    [deleteAction]: 'delete',
    [updateAction]: 'update'
}

export const hasPermissions = (models = [], tokenDetails) => {
    const { permissions = [], is_staff = false } = tokenDetails || {};
    const perms = {};

    models.forEach((model) => {
        // Handle model name mapping
        const actualModel = model === 'metrcplan' ? 'qualityplan' : model;

        if (is_staff) {
            Object.values(_crudActionsMap).forEach((action) => {
                perms[model] = { ...perms[model] ?? {}, [action]: true };
            });
            return;
        }

        // Filter permissions that match the model
        let modelPerms = permissions?.filter(perm => {
            // Handle "account.view_grow_dashboard" format
            if (perm.includes('.')) {
                const parts = perm.split('.');
                if (parts.length === 2) {
                    const [prefix, actionModel] = parts;
                    
                    // Check if it matches "view_modelname" pattern
                    if (actionModel.includes('_')) {
                        const actionPart = actionModel.split('_')[0];
                        const modelPart = actionModel.split('_').slice(1).join('_');
                        return modelPart === model || modelPart === actualModel;
                    }
                }
            }
            
            // Fallback: check if permission contains the model name
            return perm.includes(`_${actualModel}`) || perm.includes(`_${model}`);
        }) ?? [];

        let _crudOperationKeys = Object.keys(_crudActionsMap);

        modelPerms.forEach((perm) => {
            let action;

            // Handle "account.view_grow_dashboard" format
            if (perm.includes('.') && perm.includes('_')) {
                const parts = perm.split('.');
                if (parts.length === 2) {
                    action = parts[1].split('_')[0]; // Extract "view" from "view_grow_dashboard"
                }
            } else {
                // Handle other formats
                const permParts = perm.split('_');
                action = permParts[0];
            }

            let mappedAction = _crudActionsMap[action];
            if (mappedAction && _crudOperationKeys.includes(action)) {
                perms[model] = { ...perms[model], [mappedAction]: true };
            }
        });
    });

    return perms;
};